export const CurrencySymbolsLookUp: { [key: string]: string } = {
  USD: '$',
  GBP: '£'
};
